/**
 * How every master record is written in a dropdown: `CODE - NAME` when the record has a code, `NAME` when it
 * has none.
 *
 * `ENT-001` + `ABC Technologies` is `ENT-001 - ABC Technologies`; a missing, empty or blank code is just the
 * name -- never `null - Finance`, never ` - Finance`. A name that already leads with its code (the currency
 * master's own `INR - Indian Rupee`) is not prefixed twice. This is display only: what a control stores and
 * what a request sends stay the record's id, code or name, exactly as before.
 *
 * The one place the rule is written, so every dropdown -- the masters' forms, Organization Setup, Workflow
 * Config, Purchase Requests -- agrees.
 */
export function codeNameLabel(code: unknown, name: unknown): string {
  const ownCode = typeof code === 'string' ? code.trim() : '';
  const ownName = typeof name === 'string' ? name.trim() : '';
  if (ownCode === '') return ownName;
  if (ownName === '') return ownCode;
  if (ownName.startsWith(`${ownCode} - `) || ownName === ownCode) return ownName;
  return `${ownCode} - ${ownName}`;
}
